import React from "react";
import AppContainer from "./../../components/containers/AppContainer";
import { Divider, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import ItemCard from "../../components/cards/ItemCard";

const StoreItem = ({ data }) => {
  return (
    <AppContainer
      styleProps={{
        py: 2,
        my: 2,
        px: { xs: 1, sm: 3 },
      }}
    >
      <Typography fontSize={"1.125rem"} fontWeight={600}>
        Store Items
      </Typography>

      <Divider sx={{ mt: 1, mb: 2, borderColor: "#BDBDBD" }} />

      <Grid container rowSpacing={2}>
        {data?.map((val) => {
          return (
            <Grid size={12}>
              <ItemCard val={val} />
            </Grid>
          );
        })}
      </Grid>
    </AppContainer>
  );
};

export default StoreItem;
